import { useState } from "react";
import CustomButton from "./CustomButton";
import { apiHandler } from '../assets/api/index';
import { endpoint } from '../assets/api/endpoint';
import { useSelector } from "react-redux";
import '../assets/css/PaymentModal.css';
import { useNavigate } from "react-router-dom";
import { CiCreditCard1 } from "react-icons/ci";
import { toast } from "react-toastify";
import { savePaymentWay, saveTransactionId ,saveGameIdForRequestToJoin} from "../redux/UserDataSlice";
import { useDispatch } from "react-redux";
import { point } from "leaflet";

const PaymentModal = ({ onClose, PaymentWay, gameId }) => {
  const { accessToken, configurationData, saveCardDetailData } = useSelector((state) => state.loginInfo);
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const dispatch = useDispatch();

  const handleCardSelect = (paymentMethodId) => {
    setSelectedCard(paymentMethodId);
  };

  const paymentCreate = async () => {
    const result = await apiHandler({
      url: endpoint?.PAYMENT_CREATE_ONE_TIME_API,
      method: "POST",
      data: {
        paymentMethodId: selectedCard,
        amount: configurationData?.createGamePrice
      },
      authToken: accessToken.accessToken
    });
    if (result?.data && Number(result?.data?.code) !== 500) {
       dispatch(saveTransactionId(result?.data?.transactionId));
      navigate("/stripe-payment", {
        state: {
          clientSecret: result?.data?.clientSecret,
          key: result?.data?.key,
          paymentIntentId: result?.data?.paymentIntentId,            
          transactionId :  result?.data?.transactionId
        }
      });
    }
    else{
      toast.error(result?.data?.error_description)
    }
  };

  const paymentJoined = async () => {
    try {
      const result = await apiHandler({
        url: `${endpoint?.PAYMENT_JOIN_ONE_TIME_API}?gameId=${gameId}`,
        method: "POST",
        data: {
          paymentMethodId: selectedCard,
          amount: configurationData?.joinGamePrice
        },
        authToken: accessToken.accessToken
      });

      if (
        result?.data &&
        result?.data?.code !== 500 &&
        !result?.data?.user_description
      ) {
        dispatch(saveTransactionId(result?.data?.transactionId));
        navigate("/stripe-payment", {
          state: {
            clientSecret : result?.data?.clientSecret,
            key : result?.data?.key,
            paymentIntentId : result?.data?.paymentIntentId,
            transactionId : result?.data?.transactionId
          }
        });
      } else {
        toast.error(result?.data?.user_description || "Payment failed.");
      }
    } catch (error) {
      toast.error("Something went wrong while processing the payment.");
    }
  };
  
  const onPayment = () => {
    PaymentWay === 'createGame' ? paymentCreate() : paymentJoined();
    dispatch(savePaymentWay(PaymentWay));
    dispatch(saveGameIdForRequestToJoin( gameId));
  };

  const onPaymentSaveCard = (paymentIntentId) => {
    setSelectedCard(paymentIntentId)
    onPayment();
  }

  return (
    <div className="p-4">
      {saveCardDetailData?.cardDetails?.length > 0 ? (
        <div className="mb-4">
          <h3 className="font-semibold text-lg mb-2 text-center">Select a Card</h3>
          <div className="row">
            <div className="col-lg-12">

              {saveCardDetailData.cardDetails.map((card, index) => (
                <div
                  key={card.paymentMethodId}
                  onClick={() => handleCardSelect(card.paymentMethodId)}
                  style={{cursor: 'pointer'}}
                  className={`flex items-center border rounded p-3 mb-2 cursor-pointer w-100 transition-all duration-150 ${selectedCard === card.paymentMethodId
                    ? "payment-active-card"
                    :  "border-blue-500 bg-blue-50"
                    }`}
                >
                  <div className="flex flex-col w-full">
                    <div className="d-flex justify-content-between">
                      <p className="text-sm font-medium capitalize">
                        XXXX XXXX XXXX XXXX {card.last4}
                      </p>
                      <div className="flex items-center gap-2">
                        <CiCreditCard1 />
                        <span>{card.brand}</span>
                      </div>
                      <p className="text-xs text-gray-500">
                        Exp {card.expMonth}/{card.expYear}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              <div className="text-right mt-4">
                <CustomButton
                  buttonText="Go To Payment"
                  type="button"
                  className="border-gray-300"
                  style={{ borderRadius: "10px", padding: "10px 20px" }}
                  onClick={() => onPaymentSaveCard(selectedCard)}
                  disabled={!selectedCard}
                />
              </div>
            </div>

          </div>
        </div>
      ) : (
        <div className="payment-button-container text-right">
          <CustomButton
            buttonText="Go To Payment"
            type="button"
            className="border-gray-300"
            style={{ borderRadius: "10px", padding: "10px 20px" }}
            onClick={onPayment}
          />
        </div>
      )}
    </div>

  );
};

export default PaymentModal;
